export default __webpack_public_path__ + "static/media/carousel1.355b7c28.jpg";